<template>
  <div class="van-hairline--bottom">
    <section class="merchandise-info flex">
      <div class="img-container" @click="handleClick(goods)">
        <div class="mask"></div>
        <van-image class="merchandise-info__image" width="60px" height="60px" :src="goods.mainImg"></van-image>
         <span class="no-stockNum" v-if="goods.itemNum === 0">售罄</span>
      </div>

      <div class="flex-1 inline-flex merchandise-info__price">
        <section class="flex-1">
          <div class="name van-multi-ellipsis--l2">
            <div class="rtc-tip">
              <div class="prod-type" v-if="goods.rxType">
                <span class="prod-type-c" v-if="goods.rxType === RxTypeNum.CHUFANGYA0">处方药</span>
                <span class="prod-type-o" v-if="goods.rxType === RxTypeNum.OTC">OTC</span>
              </div>
            </div>
            <div class="goods-name">{{ goods.itemName }}</div>

            <template>
              <span v-if="goods.deliveryWay === 1" class="budget">仅快递</span>
              <span v-if="goods.deliveryWay === 2" class="budget">仅自提</span>
            </template>
          </div>
          <div class="spec">
            {{ goods.specifications }}
          </div>
          <div class="price-1" v-if="goods.price">
            <span style="font-size: 10px">¥</span>
            <span>{{ goods.price | price }}</span>
          </div>
        </section>
        <section class="right">
          <div class="num" v-if="goods.itemNum">x{{ goods.itemNum }}</div>
          <!-- <template v-if="goods.deliveryWay === 3">
            <van-checkbox v-model="goods.chooseDeliver" @change="handleChange(goods)" icon-size="16px">自提</van-checkbox>
          </template> -->
        </section>
      </div>
    </section>
    <section v-if="goods.deliveryWay === 3" class="delivery-section">
      <span>配送方式：</span>
      <van-radio-group v-model="goods.chooseDeliver" direction="horizontal">
        <van-radio style="margin-right: 27px" :name="1">快递</van-radio>
        <van-radio style="margin-right: 0" :name="2">自提</van-radio>
      </van-radio-group>
    </section>
  </div>
</template>

<script>
import countTo from 'vue-count-to';

export default {
  components: { countTo },
  props: {
    goods: {
      type: Object,
      default: () => {}
    },
    showOrigPrice: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      RxTypeNum: {
        CHUFANGYA0: 1,
        OTC: 2
      }
    };
  },
  methods: {
    handleClick(goods) {
      this.$router.push({
        path: '/specification',
        query: {
          from: 'preOrder',
          itemId: goods.itemId,
          isDrug: goods.isDrug
        }
      });
    },
    handleChange(goods) {
      goods.isOrigin = true;
      // if (goods.priceInfo.expressPrice !== goods.priceInfo.pickUpPrice) {
      //   this.$toast('您选购的药品因配送方式变更，价格发生变化')
      // }
    },
    toDetail(id) {},
    renderColorClass(goods) {
      if (goods.refundState === 1 || goods.refundState === 0) {
        return ['gory'];
      }
      return ['yellow'];
    }
  }
};
</script>

<style lang="less" scoped>
.flex {
  display: flex;
}
.flex-1 {
  flex: 1;
}
.inline-flex {
  display: inline-flex;
}

.merchandise-info {
  padding: 16px 0px;
  position: relative;
  &::before {
    bottom: auto;
    top: 0;
  }
  .img-container {
    position: relative;

    border-radius: 4px;

    overflow: hidden;
    margin-right: 12px;
    .no-stockNum {
    position: absolute;
    display: inline-block;
    width: 50px;
    height: 50px;
    z-index: 3;
    background: #333333;
    box-shadow: 0px 1px 4px 0px rgba(51, 51, 51, 0.5);
    opacity: 0.8;
    top: 5px;
    left: 5px;
    border-radius: 50px;
    color: #fff;
    font-size: 14px;
    text-align: center;
    line-height: 50px;
  }

    .mask {
      width: 60px;
      height: 60px;
      background: rgba(0, 0, 0, 0.02);
      z-index: 2;
      position: absolute;
      top: 0;
      left: 0;
      border-radius: 4px;
    }
  }
  .price {
    white-space: nowrap;
    font-size: 12px;
    line-height: 17px;
    color: #262626;
    text-align: right;
    font-weight: 500;
  }
  &__price {
    justify-content: space-between;
    .old-price {
      text-decoration: line-through;
      color: #bfbfbf;
      line-height: 14px;
      margin-top: 3px;
      // color: @rate-icon-disabled-color;
    }
    .name {
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #262626;
      .budget {
        min-width: 40px;
        width: 40px;
        height: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        color: #1e8dff;
        background: #ebf8ff;
        border-radius: 2.5px;
        transform: scale(0.8);
      }
      .goods-name {
        position: relative;
        height: 20px;
        line-height: 20px;
        left: 2px;
      }
      .rtc-tip {
        display: flex;
        align-items: center;
        .prod-type {
          display: inline-block;
          vertical-align: middle;
          height: 14px;
          width: 32px;
          color: #fff;
          .prod-type-o,
          .prod-type-c {
            display: inline-block;
            border-radius: 4px;
            font-size: 24px;
            background: #52c41a;
            text-align: center;
            width: 64px;
            height: 28px;
            line-height: 28px;
            font-size: 20px;
            transform: scale(0.5);
            transform-origin: 0% 0%;
          }
          .prod-type-o {
            background: #2fbb9e;
          }
        }
      }
    }
    .spec {
      color: #8c8c8c;
      margin-top: 6px;
      margin-bottom: 12px;
      font-size: 12px;
    }
    .price-1 {
      color: #262626;
    }
    .right {
      display: flex;
      flex-direction: column-reverse;
      justify-content: space-between;
      /deep/.van-checkbox__label {
        margin-left: 4px;
        color: #262626;
        font-size: 12px;
      }
    }
    .num {
      font-size: 12px;
      color: #8c8c8c;
      text-align: right;
    }
  }
}

.delivery-section {
  display: flex;
  justify-content: space-between;
  padding: 14px 0;
  > span {
    font-size: 14px;
    color: #262626;
  }
}
</style>
